import { render, staticRenderFns } from "./CorreccionesSubTab.vue?vue&type=template&id=3abcd8ba&"
import script from "./CorreccionesSubTab.vue?vue&type=script&lang=js&"
export * from "./CorreccionesSubTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports